module.exports = __webpack_public_path__ + "img/pic-rebecca-khoury.9e9e498b.jpg";